import React from 'react';

import Box from 'carbon-react/lib/components/box';
import Typography from 'carbon-react/lib/components/typography';

import { FormattedMessage } from '@futrli/localisation';

import { CreateDashboardPopover } from './components/create-dashboard-popover/create-dashboard-popover';
import { DashboardActionsProvider } from './context/dashboard-actions-context/dashboard-actions-context';
import { DashboardsTabs } from './components/tabs/dashboards-tabs';

export const DashboardsContainer = () => {
  return (
    <Box margin="auto" padding="32px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h1" fontSize="24px" fontWeight="700" mb={0}>
          <FormattedMessage id="predict.dashboards" defaultMessage="Dashboards" />
        </Typography>
        <CreateDashboardPopover />
      </Box>
      <DashboardActionsProvider>
        <DashboardsTabs />
      </DashboardActionsProvider>
    </Box>
  );
};
